import styled from "styled-components";
import { units } from "@m/alchemy-theme";
export const TOGGLE_SIZE = units(2, true);
export const BinarySelectGroupItem = styled.div `
  display: flex;
  /* IE 11 DES-2099 */
  max-width: 100%;
`;
export const BinarySelectGroup = styled.div `
  display: flex;
  flex-direction: ${({ layout }) => layout};
  align-items: start;
  margin-top: ${units(0.5)};
  flex-wrap: wrap;

  label[type="radio"] {
    span {
      top: ${({ layout }) => (layout === "row" ? `${TOGGLE_SIZE - 8}px` : "50%")};

      span {
        top: 50%;
      }
    }
  }

  gap: ${({ layout }) => (layout === "row" ? units(2) : units(1.5))};
`;
